module.exports = __webpack_public_path__ + "static/media/weather.4c7a63ba.svg";